module.exports = __webpack_public_path__ + "roboto-bold-webfont-df0f5fd966b99c0f503ae50c064fbba8.woff";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-bold-webfont.woff
// module id = 858
// module chunks = 86